module.exports = __webpack_public_path__ + "img/david-pro.66c34532.jpg";